import type { TEmitterType, TEmitterTypeValueType } from '@semios/app-platform-values-helpers-and-types'
import { getEmitterTypeToEnum } from '@semios/app-platform-values-helpers-and-types'
import type {
  TValuesCurrentIrrigationZones,
  TValuesCurrentPoints,
  TValuesCurrentProperties,
} from 'App/Map/types'

type TCurrentValuesType = TValuesCurrentPoints | TValuesCurrentIrrigationZones | TValuesCurrentProperties

export const insertEmitterType = (
  key: TEmitterTypeValueType,
  emitterType: TEmitterType,
): TCurrentValuesType =>
  key.replace(/(_ms)$/, `_${getEmitterTypeToEnum(emitterType)}$1`) as TCurrentValuesType
